import { render } from "./ProgramsSelectionView.vue?vue&type=template&id=1b0ecb57&scoped=true"
import script from "./ProgramsSelectionView.vue?vue&type=script&lang=js"
export * from "./ProgramsSelectionView.vue?vue&type=script&lang=js"

import "./ProgramsSelectionView.vue?vue&type=style&index=0&id=1b0ecb57&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0ecb57"]])

export default __exports__